import { Textarea } from '@chakra-ui/react'
import { withFormLabel } from '../../hocs/withFormLabel'
import { withFormValidation } from '../../hocs/withFormValidation'
import { withPlaceholder } from '../../hocs/withPlaceholder'

const PlaceholderTextarea = withPlaceholder(Textarea)
export const LabeledTextarea = withFormLabel(PlaceholderTextarea)
export const TrackedTextarea = withFormValidation(LabeledTextarea)
